let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iD9Hp")).then(() => parcelRequire('hN80u'));